import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

/** Persists the highest message currently rendered while a chat is foregrounded. */
@Injectable({ providedIn: 'root' })
export class ChatReadService {
  private readonly http = inject(HttpClient);
  private readonly sentByChat = new Map<number, number>();

  async markRead(chatId: number, messageId: number): Promise<void> {
    if (!Number.isSafeInteger(chatId) || !Number.isSafeInteger(messageId)) return;
    if ((this.sentByChat.get(chatId) ?? 0) >= messageId) return;
    this.sentByChat.set(chatId, messageId);
    try {
      await firstValueFrom(this.http.post('/api/chat-read', { chatId, messageId }));
    } catch {
      // Allow a later realtime message or a return to the chat to retry.
      if (this.sentByChat.get(chatId) === messageId) this.sentByChat.delete(chatId);
    }
  }
}
